import { useEffect, useState } from "react";
import { seletorDestinatariosService, SeletorDestinatarios } from "../../../services/seletorDestinatariosService";

export const useSeletoresDestinatarios = () => {
  const [seletores, setSeletores] = useState<SeletorDestinatarios[]>([]);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  const carregarSeletores = async () => {
    setLoading(true);
    setErro(null);
    try {
      const data = await seletorDestinatariosService.listarSeletoresAtivosService();
      if (data) setSeletores(data);
    } catch (error) {
      console.error("Erro ao carregar seletores:", error);
      setErro("Erro ao carregar seletores ativos.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarSeletores();
  }, []);

  return { seletores, loading, erro, carregarSeletores };
};
